import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import api from '../../../utils/api';

const NUM_LEADS_TO_FETCH = 100;
const TWO_WEEKS_AGO = 14;

function LeadContactInfo(conversation) {
  return { name: conversation.inquiry.name, conversationId: conversation.conversationId, isIncluded: true };
}

export const useGhostedLeads = (listingAlias, isMultifamily) => {
  const dispatch = useDispatch();
  const [ghostedLeads, setGhostedLeads] = useState([]);
  const [isFetchingGhostedLeads, setIsFetchingGhostedLeads] = useState(!isMultifamily);

  useEffect(() => {
    if (isMultifamily) {
      return;
    }

    setIsFetchingGhostedLeads(true);

    // start fetching leads
    (async () => {
      const allConversations = [];
      let start = 0;
      let hasNextPage = true;

      // fetch 10 leads at a time to prevent an expensive query.
      // continue fetching while there are more pages and we haven't reached the limit.
      while (hasNextPage && start < NUM_LEADS_TO_FETCH) {
        const result = await dispatch(
          api.users.leads.allLeads({
            readRepliedStatus: 'notRepliedTo',
            daysBack: TWO_WEEKS_AGO,
            listingAlias,
            limit: 10,
            start,
          }),
        );

        const conversations = result?.response?.conversations ?? [];
        allConversations.push(...conversations);

        hasNextPage = result?.response?.hasNextPage ?? false;
        start += 10;
      }

      setGhostedLeads(allConversations.map(LeadContactInfo));
      setIsFetchingGhostedLeads(false);
    })();
  }, [dispatch, isMultifamily, listingAlias]);

  const toggleIncludeLead = useCallback(
    (i) => {
      const newGhostedLeads = [...ghostedLeads];
      newGhostedLeads[i].isIncluded = !ghostedLeads[i].isIncluded;
      setGhostedLeads(newGhostedLeads);
    },
    [ghostedLeads, setGhostedLeads],
  );

  return { ghostedLeads, toggleIncludeLead, isFetchingGhostedLeads };
};

export const useNotAvailableMessage = (street, name) => {
  const [notAvailableMessage, setNotAvailableMessage] = useState('');

  useEffect(() => {
    setNotAvailableMessage(`Hello,

The ${street} property you inquired about is no longer available. Thank you for your interest.

Best regards,

${name}`);
  }, [street, name]);

  return { notAvailableMessage, setNotAvailableMessage };
};
